/**
 * SEO Meta Data Configuration
 * Centralní mapování route → SEO metadata
 */

const BASE_URL = process.env.REACT_APP_BASE_URL || 'https://nis2ochrana.cz';
const SITE_NAME = 'NIS2 Ochrana';

export const pageMeta = {
  '/': {
    title: 'NIS2 Ochrana | Ochraňte svou firmu před sankcemi až 10 milionů EUR',
    description: 'Komplexní řešení pro zajištění compliance s NIS2 směrnicí EU. Profesionální příprava, implementace a udržování kybernetické bezpečnosti.',
  },
  '/nis2': {
    title: 'NIS2 přehled | Co musíte stihnout do 1. 11. 2025',
    description: 'Shrnutí povinností, dopadů a praktických kroků k NIS2. Zjistěte, zda spadáte do režimu essential nebo important a jak se připravit na audit.',
  },
  '/povinnosti-nis2': {
    title: 'Povinnosti podle NIS2 | Kompletní přehled požadavků',
    description: 'Kompletní přehled všech technických a organizačních požadavků, které musíte splnit pro zajištění compliance s NIS2 směrnicí.',
  },
  '/priprava-na-nis2': {
    title: 'Příprava na NIS2 | 5-ti fázový proces implementace',
    description: 'Systematický 5-ti fázový proces, který vás bezpečně provede implementací všech požadavků NIS2 směrnice.',
  },
  '/nis2-koho-se-tyka': {
    title: 'Koho se týká NIS2? | Zjistěte, zda se vás směrnice týká',
    description: 'Směrnice NIS2 se vztahuje na tisíce organizací v EU. Zjistěte, zda spadáte mezi regulované subjekty a jaké povinnosti vás čekají.',
  },
  '/vyhody-nis2': {
    title: 'Výhody implementace NIS2 | Proč investovat do kybernetické bezpečnosti',
    description: 'NIS2 není jen compliance, je to investice do budoucnosti vaší firmy. Objevte všechny výhody implementace NIS2 směrnice.',
  },
  '/kyberneticke-incidenty': {
    title: 'Kybernetické incidenty | Hlášení a řešení podle NIS2',
    description: 'Zjistěte, jak správně hlásit a řešit kybernetické incidenty podle požadavků NIS2 směrnice.',
  },
  '/nis2-smernice': {
    title: 'NIS2 Směrnice EU | Kompletní průvodce',
    description: 'Kompletní průvodce NIS2 směrnicí EU o kybernetické bezpečnosti. Vše, co potřebujete vědět o směrnici a jejích požadavcích.',
  },
  '/blog': {
    title: 'Blog | Aktuální články o NIS2 a kybernetické bezpečnosti',
    description: 'Nejnovější články, tipy a best practices pro implementaci NIS2 směrnice. Zůstaňte informováni o aktuálních trendech a požadavcích.',
  },
  '/10-otazek-ktere-si-musi-polozit-kazda-firma-pred-nis2': {
    title: '10 otázek, které si musí položit každá firma před NIS2',
    description: 'Objevte nejdůležitější otázky, které by si měla položit každá firma připravující se na NIS2 směrnici. Od základní identifikace až po pokročilé implementační strategie.',
  },
  '/rozdil-mezi-smernici-a-zakonem-proc-nis2-jeste-neni-povinnosti': {
    title: 'Rozdíl mezi směrnicí a zákonem – proč NIS2 ještě není povinností?',
    description: 'Směrnice NIS2: Co znamená pro firmy a proč by vás to mělo zajímat už teď. Zjistěte, kdy bude zákon účinný a proč je důležité začít s přípravou už nyní.',
  },
  '/blog/povinnosti-nis2-kompletni-pruvodce': {
    title: 'Povinnosti NIS2: Kompletní průvodce pro 2024',
    description: 'NIS2 směrnice přináší nové povinnosti pro organizace v oblasti kybernetické bezpečnosti. Zjistěte, co musíte splnit a jak se připravit.',
  },
  '/blog/jak-spravne-hlasit-kyberneticke-incidenty': {
    title: 'Jak správně hlásit kybernetické incidenty',
    description: 'Ochrana vaší organizace začíná správným hlášením kybernetických incidentů. Zjistěte, jak na to podle NIS2.',
  },
  '/kontakt': {
    title: 'Kontakt | NIS2 Ochrana - Kontaktujte nás pro konzultaci',
    description: 'Kontaktujte nás pro bezplatnou konzultaci ohledně implementace NIS2. Máte dotaz nebo potřebujete pomoci s NIS2 compliance? Jsme tu pro vás.',
  },
  '/o-nas': {
    title: 'O nás | NIS2 Ochrana - Expertní tým pro implementaci NIS2',
    description: 'Poznejte NIS2 Ochrana - komplexní platformu pro implementaci NIS2 směrnice. Pomáháme firmám splnit všechny požadavky NIS2 a zajistit kybernetickou bezpečnost. Specializujeme se výhradně na NIS2 compliance.',
  },
  '/pricing': {
    title: 'Ceník | NIS2 Ochrana',
    description: 'Transparentní ceník našich služeb pro implementaci NIS2. Vyberte si balíček, který nejlépe vyhovuje vašim potřebám.',
  },
  '/pricing_desktop': {
    title: 'Ceník | NIS2 Ochrana',
    description: 'Transparentní ceník našich služeb pro implementaci NIS2. Vyberte si balíček, který nejlépe vyhovuje vašim potřebám.',
  },
  '/webinar': {
    title: 'NIS2 Webinář | Připravte svou organizaci na novou legislativu',
    description: 'Živý online webinář NIS2 Ochrany, který Vám za hodinu ukáže, co přesně musíte pro NIS2 udělat, jaké povinnosti se Vás týkají a jak nastavit praktický plán přípravy.',
  },
  '/ebook-1': {
    title: 'Základní E-book o směrnici NIS2 | Stáhněte zdarma',
    description: 'E-book s důležitými informacemi o NIS2 zcela zdarma. Zjistěte, co je NIS2, koho se týká, jaké má požadavky a v čem spočívají povinnosti.',
  },
  '/ebook-2': {
    title: 'E-book NIS2 | Kompletní průvodce implementací',
    description: 'Stáhněte si náš detailní e-book o implementaci NIS2. Kompletní průvodce krok za krokem.',
  },
  '/nis2-v-praxi-tri-pilire-uspesneho-projektu-pravo-lide-technologie': {
    title: 'NIS2 v praxi: tři pilíře úspěšného projektu (právo, lidé, technologie) | NIS2 Ochrana',
    description: 'Nový zákon o kybernetické bezpečnosti č. 264/2025 Sb. je účinný od 1. listopadu 2025. Úspěšné projekty NIS2 nestojí jen na IT, ale na třech pilířích: právo a governance, lidé a školení, technologie a důkazy.',
  },
  '/nis2-reality-check-2025-vetsina-firem-neni-ready-a-cas-nebezi-pro-vas': {
    title: 'NIS2 reality check 2025: většina firem není ready (a čas neběží pro vás) | NIS2 Ochrana',
    description: 'Směrnice NIS2 je v platnosti od konce roku 2022, ale realita roku 2025 je jednoduchá: většina firem v EU ji reálně nezvládá. Zjistěte, proč se tolik organizací topí a co s tím dělat.',
  },
  '/souhlas-se-zpracovanim-osobnich-udaju': {
    title: 'Souhlas se zpracováním osobních údajů | GDPR',
    description: 'Informace o zpracování osobních údajů podle GDPR.',
  },
  '/faq': {
    title: 'FAQ | Často kladené otázky o NIS2',
    description: 'Odpovědi na nejčastější otázky o NIS2 směrnici, implementaci a compliance.',
  },
};

/**
 * Získat SEO metadata pro danou route
 */
export const getPageMeta = (pathname) => {
  // Normalizace pathname (odstranění trailing slash)
  const normalizedPath = pathname.endsWith('/') && pathname !== '/' 
    ? pathname.slice(0, -1) 
    : pathname;
  
  return pageMeta[normalizedPath] || {
    title: 'NIS2 Ochrana | Kybernetická bezpečnost',
    description: 'Komplexní řešení pro zajištění compliance s NIS2 směrnicí EU.',
  };
};

/**
 * Získat plnou URL pro danou route
 */
export const getPageUrl = (pathname) => {
  const normalizedPath = pathname.startsWith('/') ? pathname : `/${pathname}`;
  return `${BASE_URL}${normalizedPath}`;
};

export { BASE_URL, SITE_NAME };

